'use strict';

var iti = require('../common/phone-iti');

var validateMaxLength = require('../common/validate-maxlength');
var validatePhoneNumber = require('../common/validate-phonenumber');
var validateSelect = require('../common/validate-select');
var validateTextField = require('../common/validate-textfield');
var validateEmail = require('../common/validate-email');

module.exports = {
	init: function () {
		if (window.jQuery('#editProfessionalProfile').length > 0) {
			window.jQuery('#editProfessionalProfile').on('submit', validateEditProProfile);

			//for domestic addresses, use state dropdown; for international, use text input
			window.jQuery('#homenation').on('change', function () {
				toggleStateControl(
					window.jQuery(this),
					window.iq.domesticNationValue,
					window.jQuery(this).closest('.addressContainer')
				);
			});
			window.jQuery('#busnation').on('change', function () {
				toggleStateControl(
					window.jQuery(this),
					window.iq.domesticNationValue,
					window.jQuery(this).closest('.addressContainer')
				);
			});

			window.jQuery('.nation,.state-dropdown').select2();

			iti.setup_input('#workphonenumberinput', '#workphonenumber');
			window.jQuery('.select2-default-dropdown').select2({});
		}
	}
};

function validateEditProProfile() {
	var error = false;
	// force the itl phone tool to format the damn number before submitting
	window.jQuery('#workphonenumberinput').blur();

	error = validateTextField('.requireText') || error;
	error = validateSelect('.requireSelect') || error;
	error = validateMaxLength('.checkLength') || error;

	error = validatePhoneNumber('#workphonenumberinput') || error;

	if (window.jQuery('#workemailaddress').val() != '') {
		error = validateEmail('#workemailaddress') || error;
	}

	if (error) {
		window.alert('Not quite complete - please review all fields highlighted in red.');
	}
	return !error;
}

function toggleStateControl($nationControl, domesticValue, $addressContainer) {
	if ($nationControl.val() !== domesticValue) {
		$addressContainer.find('.showIntl').removeClass('hide').find('input,select').removeAttr('disabled');
		$addressContainer.find('.hideIntl').addClass('hide').find('input,select').attr('disabled', 'disabled');
	} else {
		$addressContainer.find('.showIntl').addClass('hide').find('input,select').attr('disabled', 'disabled');
		$addressContainer.find('.hideIntl').removeClass('hide').find('input,select').removeAttr('disabled');
	}
}
